// Catalogo delle SOLE card di secondo livello (Ufficio) preferibili.
// Fonte unica per: presenza della stella, identità visiva (colore/icona) nella sidebar.
import {
  Users, Clock, FileCheck, Radio, UserRound,
  School, Building2, FileSearch, PenSquare, Inbox, Puzzle, ArrowRightLeft,
} from "lucide-react";

// Aree "Comunicazioni e Verifiche" → identità antracite (coerente con la Home Ufficio).
const COMM_GROUPS = new Set(["controlli", "check-esterni", "comunicazioni-generali"]);

// section -> { group, label, icon }. Ogni sezione appartiene a un solo gruppo.
export const FAV_SECTIONS = {
  lavoratori: { group: "inserimento", label: "Lavoratori", icon: Users },
  scuole: { group: "inserimento", label: "Scuole per assistenza scolastica", icon: School },
  utenti: { group: "inserimento", label: "Utenti e gruppi", icon: UserRound },
  "sedi-operative": { group: "inserimento", label: "Sedi operative", icon: Building2 },
  matchmaking: { group: "inserimento", label: "Assegnazioni", icon: Puzzle },
  "elenco-assegnazioni": { group: "inserimento", label: "Sostituzioni", icon: ArrowRightLeft },
  giustificativi: { group: "controlli", label: "Richieste giustificativi", icon: FileCheck },
  timbrature: { group: "controlli", label: "Timbrature", icon: Clock },
  operatori: { group: "controlli", label: "Operatori in servizio", icon: Radio },
  "check-assistenza-scolastica": { group: "check-esterni", label: "Check Assistenza Scolastica", icon: FileSearch },
  "check-adm": { group: "check-esterni", label: "Check ADM", icon: FileSearch },
  "comunicazione-nuova": { group: "comunicazioni-generali", label: "Nuova comunicazione", icon: PenSquare },
  "comunicazioni-inviate": { group: "comunicazioni-generali", label: "Comunicazioni inviate", icon: Inbox },
};

export function isFavoritable(section) {
  return Boolean(FAV_SECTIONS[section]);
}

// Risolve un Preferito {group, section} in metadati di rendering (icona/etichetta/identità colore).
export function favMeta(section) {
  const m = FAV_SECTIONS[section];
  if (!m) return null;
  return { ...m, variant: COMM_GROUPS.has(m.group) ? "comm" : "default" };
}
